import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/LogoW.webp';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const pendingBooking = JSON.parse(localStorage.getItem('pixly_pending_booking') || 'null');
      const user = await login(form.email, form.password, pendingBooking);
      if (pendingBooking) {
        localStorage.removeItem('pixly_pending_booking');
      }
      if (user.role === 'admin') {
        navigate('/admin', { replace: true });
      } else if (user.role === 'event_organizer') {
        navigate('/organizer', { replace: true });
      } else {
        navigate(from, { replace: true });
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0B0F1F', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: 'Arial, Helvetica, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Link to="/"><img src={logo} alt="PixlyBooth" style={{ maxWidth: 160 }} /></Link>
        </div>

        {/* Card */}
        <div style={{ background: 'linear-gradient(135deg, #101428 0%, #0D0F20 100%)', borderRadius: 18, padding: 32, border: '1px solid rgba(227,67,100,0.3)', boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
          <h1 style={{ margin: '0 0 4px', fontSize: 22, color: '#E34364', fontWeight: 700 }}>Welcome back</h1>
          <p style={{ margin: '0 0 28px', fontSize: 13, color: '#a0a0b8' }}>Sign in to your Pixly Booth account</p>

          {error && (
            <div style={{ background: 'rgba(227,67,100,0.1)', border: '1px solid rgba(227,67,100,0.3)', borderRadius: 10, padding: '12px 16px', marginBottom: 20, color: '#E34364', fontSize: 13 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Email Address</label>
              <input
                type="email" required autoComplete="email"
                value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                placeholder="you@example.com"
              />
            </div>
            <div style={{ marginBottom: 8 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Password</label>
              <input
                type="password" required autoComplete="current-password"
                value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                placeholder="••••••••"
              />
            </div>
            <div style={{ textAlign: 'right', marginBottom: 24 }}>
              <Link to="/forgot-password" style={{ fontSize: 12, color: '#9F5CFF', textDecoration: 'none' }}>Forgot password?</Link>
            </div>

            <button
              type="submit" disabled={loading}
              style={{ width: '100%', background: loading ? '#555' : '#E34364', color: '#fff', border: 'none', borderRadius: 50, padding: '14px 0', fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', transition: 'all 0.2s' }}
            >
              {loading ? 'Signing in…' : 'Sign In →'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: '#a0a0b8' }}>
            Don't have an account?{' '}
            <Link to="/signup" style={{ color: '#E34364', textDecoration: 'none', fontWeight: 600 }}>Create one</Link>
          </p>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#555' }}>
          <Link to="/" style={{ color: '#555', textDecoration: 'none' }}>← Back to homepage</Link>
        </p>
      </div>
    </div>
  );
}
